/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prices_Title_LeadInputs */

const en_prices_title_lead = /** @type {(inputs: Prices_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf lessons,`)
};

const es_prices_title_lead = /** @type {(inputs: Prices_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lecciones de golf,`)
};

const de_prices_title_lead = /** @type {(inputs: Prices_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golfunterricht,`)
};

const zh_prices_title_lead = /** @type {(inputs: Prices_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高尔夫课程，`)
};

const ar_prices_title_lead = /** @type {(inputs: Prices_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دروس غولف،`)
};

const fr_prices_title_lead = /** @type {(inputs: Prices_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cours de golf,`)
};

const vi_prices_title_lead = /** @type {(inputs: Prices_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bài học golf,`)
};

const sw_prices_title_lead = /** @type {(inputs: Prices_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mafunzo ya gofu,`)
};

const th_prices_title_lead = /** @type {(inputs: Prices_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บทเรียนกอล์ฟ สนามไดร์ฟ`)
};

const bs_prices_title_lead = /** @type {(inputs: Prices_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lekcije golfa,`)
};

const ja_prices_title_lead = /** @type {(inputs: Prices_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ゴルフレッスン、`)
};

const ko_prices_title_lead = /** @type {(inputs: Prices_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`골프 레슨,`)
};

const pt_prices_title_lead = /** @type {(inputs: Prices_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aulas de golfe,`)
};

const it_prices_title_lead = /** @type {(inputs: Prices_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lezioni di golf,`)
};

const sv_prices_title_lead = /** @type {(inputs: Prices_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golflektioner,`)
};

const nl_prices_title_lead = /** @type {(inputs: Prices_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golflessen,`)
};

const da_prices_title_lead = /** @type {(inputs: Prices_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golfundervisning,`)
};

const nb_prices_title_lead = /** @type {(inputs: Prices_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golftimer,`)
};

const fi_prices_title_lead = /** @type {(inputs: Prices_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golftunteja,`)
};

const pl_prices_title_lead = /** @type {(inputs: Prices_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lekcje golfa,`)
};

const ru_prices_title_lead = /** @type {(inputs: Prices_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уроки гольфа,`)
};

const tr_prices_title_lead = /** @type {(inputs: Prices_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf dersleri,`)
};

const hi_prices_title_lead = /** @type {(inputs: Prices_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गोल्फ सबक`)
};

const id_prices_title_lead = /** @type {(inputs: Prices_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelajaran Golf,`)
};

const ms_prices_title_lead = /** @type {(inputs: Prices_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelajaran golf,`)
};

const cs_prices_title_lead = /** @type {(inputs: Prices_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lekce golfu,`)
};

const el_prices_title_lead = /** @type {(inputs: Prices_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Μαθήματα γκολφ,`)
};

const he_prices_title_lead = /** @type {(inputs: Prices_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שיעורי גולף,`)
};

const af_prices_title_lead = /** @type {(inputs: Prices_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golflesse,`)
};

const hu_prices_title_lead = /** @type {(inputs: Prices_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golfórák,`)
};

/**
* | output |
* | --- |
* | "Golf lessons," |
*
* @param {Prices_Title_LeadInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const prices_title_lead = /** @type {((inputs?: Prices_Title_LeadInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prices_Title_LeadInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_prices_title_lead(inputs)
	if (locale === "de") return de_prices_title_lead(inputs)
	if (locale === "zh") return zh_prices_title_lead(inputs)
	if (locale === "ar") return ar_prices_title_lead(inputs)
	if (locale === "fr") return fr_prices_title_lead(inputs)
	if (locale === "vi") return vi_prices_title_lead(inputs)
	if (locale === "sw") return sw_prices_title_lead(inputs)
	if (locale === "th") return th_prices_title_lead(inputs)
	if (locale === "bs") return bs_prices_title_lead(inputs)
	if (locale === "ja") return ja_prices_title_lead(inputs)
	if (locale === "ko") return ko_prices_title_lead(inputs)
	if (locale === "pt") return pt_prices_title_lead(inputs)
	if (locale === "it") return it_prices_title_lead(inputs)
	if (locale === "sv") return sv_prices_title_lead(inputs)
	if (locale === "nl") return nl_prices_title_lead(inputs)
	if (locale === "da") return da_prices_title_lead(inputs)
	if (locale === "nb") return nb_prices_title_lead(inputs)
	if (locale === "fi") return fi_prices_title_lead(inputs)
	if (locale === "pl") return pl_prices_title_lead(inputs)
	if (locale === "ru") return ru_prices_title_lead(inputs)
	if (locale === "tr") return tr_prices_title_lead(inputs)
	if (locale === "hi") return hi_prices_title_lead(inputs)
	if (locale === "id") return id_prices_title_lead(inputs)
	if (locale === "ms") return ms_prices_title_lead(inputs)
	if (locale === "cs") return cs_prices_title_lead(inputs)
	if (locale === "el") return el_prices_title_lead(inputs)
	if (locale === "he") return he_prices_title_lead(inputs)
	if (locale === "af") return af_prices_title_lead(inputs)
	if (locale === "hu") return hu_prices_title_lead(inputs)
	return en_prices_title_lead(inputs)
});